import type { TOC } from '@ember/component/template-only'
import PopoverStandardDropdown from '@blakeelearning/popovers/components/popover/dropdowns/standard'
import PhosphorIcon from 'teacher-ui-client/components/phosphor-icon'
import { t } from 'ember-intl'
import { eq } from 'ember-truth-helpers'
import { fn } from '@ember/helper'
import { on } from '@ember/modifier'
import type { FilterKey, PrimaryFilter } from 'teacher-ui-client/reading-scales/utils'

interface Signature {
  Element: HTMLButtonElement
  Args: {
    label?: string
    condensedList?: boolean
    primaryFilters: PrimaryFilter[]
    currentPrimaryFilter: PrimaryFilter
    onPrimaryFilterChange: (primaryFilterKey: FilterKey) => void
  }
}

export const BookLibraryPrimaryFilterSelect: TOC<Signature> = <template>
  <PopoverStandardDropdown @matchTriggerWidth={{true}} @contentY="below" as |dropdown status actions|>
    <button
      data-test-dropdown-trigger
      type="button"
      class="text-dusty-black-250 rounded-t-md border-t border-r border-l text-center whitespace-nowrap select-none focus:outline-hidden
        {{if status.isOpen 'border-dusty-black-100 shadow-xl' 'border-transparent'}}"
      {{dropdown.makeTrigger}}
      ...attributes
    >
      {{#if @label}}
        <span class="mr-6">{{@label}}</span>
      {{/if}}
      <span data-test-primary-filter-name class="mr-2 inline-block min-w-[50px] text-center">
        {{t @currentPrimaryFilter.translationKey}}
      </span>
      <PhosphorIcon
        @icon={{if status.isOpen "phosphor-caret-up-bold" "phosphor-caret-down-bold"}}
        class="h-3.5 w-3.5 print:hidden"
      />
    </button>
    <dropdown.content>
      <div
        data-test-dropdown-content
        class="border-dusty-black-100 rounded-b-md border-r border-b border-l bg-white shadow-xl"
      >
        {{! Content top border, should line up with the controls border }}
        <div class="border-dusty-black-50 mx-4 border-t-2"></div>
        <ul class="p-4 {{unless @condensedList 'ml-[10%]'}}">
          {{#each @primaryFilters as |primaryFilter|}}
            <li>
              <label
                data-test-primary-filter-option={{primaryFilter.id}}
                class="hover:bg-dusty-black-50 w-full cursor-pointer p-2 font-normal"
              >
                <input
                  class="mr-2 cursor-pointer align-middle"
                  type="radio"
                  name="select-primary-filter"
                  value={{primaryFilter.id}}
                  checked={{eq @currentPrimaryFilter.id primaryFilter.id}}
                  {{on "input" (fn @onPrimaryFilterChange primaryFilter.id)}}
                  {{on "input" actions.close}}
                />
                <span class="align-middle">{{t primaryFilter.translationKey}}</span>
              </label>
            </li>
          {{/each}}
        </ul>
      </div>
    </dropdown.content>
  </PopoverStandardDropdown>
</template>

export default BookLibraryPrimaryFilterSelect
